import { render, staticRenderFns } from "./SupplierWarehouse.vue?vue&type=template&id=8f463e78&scoped=true"
import script from "./SupplierWarehouse.vue?vue&type=script&lang=ts"
export * from "./SupplierWarehouse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f463e78",
  null
  
)

export default component.exports